import { Card, CardContent } from '../ui/card';

export function AdminStatsGrid({ stats }) {
  const statCards = [
    { label: 'Utilisateurs', value: stats?.total_users || 0, color: 'text-blue-400' },
    { label: 'Gratuit', value: stats?.free_users || 0, color: 'text-slate-400' },
    { label: 'Pro', value: stats?.pro_users || 0, color: 'text-amber-400' },
    { label: 'Demandes', value: stats?.pending_requests || 0, color: 'text-rose-400' },
    { label: 'QCM créés', value: stats?.total_quizzes || 0, color: 'text-emerald-400' },
    { label: 'Copies scannées', value: stats?.total_results || 0, color: 'text-violet-400' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 stagger-children">
      {statCards.map((s) => (
        <Card key={s.label} className="bg-card border-border">
          <CardContent className="p-4">
            <p className={`text-2xl font-black ${s.color}`}>{s.value}</p>
            <p className="text-xs text-muted-foreground">{s.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
